import { render, staticRenderFns } from "./10.vue?vue&type=template&id=0118b7bc&scoped=true&"
import script from "./10.vue?vue&type=script&lang=js&"
export * from "./10.vue?vue&type=script&lang=js&"
import style0 from "./10.vue?vue&type=style&index=0&id=0118b7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0118b7bc",
  null
  
)

export default component.exports